export default __webpack_public_path__ + "static/media/icon-moon.6c03114b.svg";